const filterConfig = {
  type: 'object',
  properties: {      
      search: {
          type: 'string',
      },
      status: {
          type: 'integer',
          default: 2 // Payed
      },
    }
}
const getCustomerFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getCustomerFiltersConfig;